<!-- src/components/PreReceiveTab.vue -->
<template>
  <div class="sub-tabs">
    <el-tabs v-model="activeSubTab">
      <!-- 预收明细 -->
      <el-tab-pane label="预收明细" name="detail">
        <div class="search-box">
          <div class="left">
            <div class="child">
              <DateSelect ref="dateSelect" @change="dateChange">结算日期：</DateSelect>
            </div>
            <div class="child">
              <span class="label">单据号：</span>
              <el-input v-model="searchParams.billNo" placeholder="请输入预收单号、来源单号" size="mini" clearable />
            </div>
            <div class="child">
              <span class="label">余额筛选：</span>
              <el-select v-model="searchParams.balance" placeholder="全部" size="mini">
                <el-option label="全部" :value="0" />
                <el-option label="有余额" :value="1" />
                <el-option label="无余额" :value="2" />
              </el-select>
            </div>
            <div class="child" style="margin-left: 12px;">
              <el-button type="primary" size="mini" @click="handleDetailSearch">查询</el-button>
              <el-button size="mini" @click="handleDetailReset">重置</el-button>
            </div>
          </div>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tableData"
            @sort-change="sortChange"
            border
            stripe
            style="width:100%;"
            size="small"
            show-summary
            :summary-method="getSummaries1"
            v-loading="loading"
          >
            <el-table-column label="序号" width="60" align="center" type="index" fixed></el-table-column>
            <el-table-column label="操作" width="100" align="center" fixed>
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="handleView(scope.row)">查看冲销明细</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="billNo"
              label="预收单号"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="180"
            />
            <el-table-column
              prop="amount"
              label="金额"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">{{ scope.row.amount }}</template>
            </el-table-column>
            <el-table-column
              prop="deductedAmount"
              label="已冲金额"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">{{ scope.row.deductedAmount }}</template>
            </el-table-column>
            <el-table-column
              prop="balanceAmount"
              label="余额"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">{{ scope.row.balanceAmount }}</template>
            </el-table-column>
            <el-table-column
              prop="paymentType"
              label="支付方式"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="110"
            />
            <el-table-column
              prop="sourceBillNo"
              label="来源单号"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="200"
            />
            <el-table-column
              prop="sourceType"
              label="来源单据类型"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="130"
            />
            <el-table-column
              prop="sourceBillTypeCn"
              label="来源单据状态"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="130"
            >
            </el-table-column>
            <el-table-column
              prop="createdAt"
              label="登记日期"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="200"
            />
            <el-table-column
              prop="settleDate"
              label="最后结算日期"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="130"
            />
          </el-table>
        </div>

        <div style="margin-top:12px;text-align:right;">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-size="searchParams.pageSize"
            :current-page.sync="searchParams.page"
            @size-change="
              s => {
                searchParams.pageSize = s;
                getList();
              }
            "
            @current-change="
              p => {
                searchParams.page = p;
                getList();
              }
            "
          />
        </div>
      </el-tab-pane>

      <!-- 冲销明细 -->
      <el-tab-pane label="冲销明细" name="writeoff">
        <div class="search-box">
          <div class="left">
            <div class="child">
              <DateSelect ref="dateSelect2" @change="dateChange2">结算日期：</DateSelect>
            </div>
            <div class="child">
              <span class="label">单据号：</span>
              <el-input
                v-model="searchParams2.billNo"
                placeholder="请输入冲销单号、来源单号、预收单号"
                size="mini"
                clearable
              />
            </div>
            <div class="child">
              <span class="label">冲销单据类型：</span>
              <el-select
                v-model="searchParams2.sourceBillTypes"
                multiple
                collapse-tags
                placeholder="全部"
                size="mini"
                clearable
              >
                <el-option v-for="item in billtypeList" :label="item.name" :value="item.code" :key="item.code" />
              </el-select>
            </div>
            <div class="child" style="margin-left: 12px;">
              <el-button type="primary" size="mini" @click="handleWriteoffSearch">查询</el-button>
              <el-button size="mini" @click="handleWriteoffReset">重置</el-button>
            </div>
          </div>
        </div>

        <div class="table-wrap">
          <el-table :data="tableData2" border stripe style="width:100%;" size="small" v-loading="loading2">
            <el-table-column label="序号" width="60" align="center" type="index" fixed></el-table-column>
            <el-table-column
              prop="settleDate"
              label="最后结算时间"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="140"
            />
            <el-table-column
              prop="billNo"
              label="冲销单号"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="200"
            />
            <el-table-column
              prop="amount"
              label="冲销金额"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">{{ scope.row.amount }}</template>
            </el-table-column>
            <el-table-column
              prop="createdBy"
              label="冲销登记人"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="140"
            />
            <el-table-column
              prop="sourceBillNo"
              label="来源单号"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="280"
            />
            <el-table-column
              prop="sourceBillType"
              label="来源单据类型"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="130"
            />
            <el-table-column
              prop="settleBy"
              label="冲销结算人"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="140"
            />
            <el-table-column
              prop="header.billNo"
              label="预收单号"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">{{ scope.row.header?.billNo }}</template>
            </el-table-column>
            <el-table-column
              prop="header.createdAt"
              label="预收登记日期"
              show-overflow-tooltip
              sortable="custom"
              align="center"
              min-width="140"
            >
              <template slot-scope="scope">{{ scope.row.header?.createdAt }}</template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top:12px;text-align:right;">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
            :page-size="searchParams2.pageSize"
            :current-page.sync="searchParams2.page"
            @size-change="
              s => {
                searchParams2.pageSize = s;
                getList2();
              }
            "
            @current-change="
              p => {
                searchParams2.page = p;
                getList2();
              }
            "
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { preFundInList, prevFundInLogs, billTypes } from "@/api/reconciliation";
import DateSelect from "@/components/DateSelect";
const dateRange = window.tool.getDateRangeByName("本月");
export default {
  name: "PreReceiveTab",
  components: { DateSelect },
  data() {
    return {
      searchParams: {
        balance: 1, //# 余额状态 0全部；1有余额；2无余额
        billNo: "",
        settleDateStart: dateRange[0],
        settleDateEnd: dateRange[1],
        sort: "",
        page: 1,
        pageSize: 10
      },
      searchParams2: {
        billNo: "",
        sourceBillTypes: [],
        settleDateStart: dateRange[0],
        settleDateEnd: dateRange[1],
        sort: "",
        page: 1,
        pageSize: 10
      },
      activeSubTab: "detail",
      tableData: [],
      total: 0,
      tableData2: [],
      total2: 0,
      loading: false,
      loading2: false,
      billtypeList: [],
      totalInfo: {},
      totalInfo2: {}
    };
  },
  mounted() {
    this.getList();
    this.getList2();
    this.getBillTypes();
  },
  methods: {
    //获取来源类型
    getBillTypes() {
      billTypes().then(res => {
        this.billtypeList = res || [];
      });
    },
    dateChange(dateObj) {
      this.searchParams.settleDateStart = dateObj.startDate;
      this.searchParams.settleDateEnd = dateObj.endDate;
    },
    dateChange2(dateObj) {
      this.searchParams2.settleDateStart = dateObj.startDate;
      this.searchParams2.settleDateEnd = dateObj.endDate;
    },
    // 预收明细表格合计行计算方法
    getSummaries1(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["amount", "deductedAmount", "balanceAmount"];
        if (sumFields.includes(prop)) {
          sums[index] = this.totalInfo[prop]; // 保留两位小数
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    getSummaries2(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const prop = column.property;
        // 需要对哪些列进行合计
        const sumFields = ["amount"];
        if (sumFields.includes(prop)) {
          sums[index] = this.totalInfo2[prop]; // 保留两位小数
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    sortChange2({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams2.sort = `${prop}-desc`;
        } else {
          this.searchParams2.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams2.sort = "";
      }
      this.getList2();
    },
    getList2() {
      this.loading2 = true;
      prevFundInLogs(this.searchParams2)
        .then(res => {
          this.tableData2 = res.rows || [];
          this.total2 = res.totalSize;
          this.totalInfo2 = {
            amount: res.totalAmount
          };
        })
        .catch(err => {
          this.tableData2 = [];
          this.total2 = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    sortChange({ prop, order }) {
      if (order) {
        if (order.includes("desc")) {
          this.searchParams.sort = `${prop}-desc`;
        } else {
          this.searchParams.sort = `${prop}-asc`;
        }
      } else {
        this.searchParams.sort = "";
      }
      this.getList();
    },
    getList() {
      this.loading = true;
      preFundInList(this.searchParams)
        .then(res => {
          this.tableData = res.rows || [];
          this.total = res.totalSize;
          this.totalInfo = {
            amount: res.totalAmount,
            deductedAmount: res.totalDeductedAmount,
            balanceAmount: res.totalBalanceAmount
          };
        })
        .catch(err => {
          this.tableData = [];
          this.total = 0;
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDetailSearch() {
      this.searchParams.page = 1;
      this.getList();
    },
    handleDetailReset() {
      this.searchParams = {
        balance: 1, //# 余额状态 0全部；1有余额；2无余额
        billNo: "",
        // settleDateStart: "",
        // settleDateEnd: "",
        sort: "",
        page: 1,
        pageSize: this.searchParams.pageSize
      };
      this.$refs.dateSelect.reset();
      this.$refs.dateSelect.confirm();
      this.getList();
    },
    handleWriteoffSearch() {
      this.searchParams2.page = 1;
      this.getList2();
    },
    handleWriteoffReset() {
      this.searchParams2 = {
        billNo: "",
        sourceBillTypes: [],
        settleDateStart: "",
        settleDateEnd: "",
        sort: "",
        page: 1,
        pageSize: this.searchParams2.pageSize
      };
      this.$refs.dateSelect2.reset();
      this.$refs.dateSelect2.confirm();
      this.getList2();
    },
    handleView(row) {
      this.searchParams2.billNo = row.billNo;
      this.activeSubTab = "writeoff";
      this.getList2();
    },
    statusClass(type) {
      const map = { 已完成: "done", 执行中: "wait", 待执行: "pending" };
      return "tag-status " + (map[type] || "default");
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-tabs .el-tabs__header {
  margin-bottom: 8px;
}
.sub-tabs .el-tabs__item {
  font-size: 14px;
}
.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: rgba(249, 249, 249, 1);
  .left {
    display: flex;
    align-items: center;
    .child {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        color: #555555;
        min-width: 80px;
        text-align: right;
      }
    }
  }
}
.table-wrap {
  margin-top: 4px;
  overflow-x: auto;
}
.table-wrap .el-table {
  font-size: 13px;
}
.tag-status {
  font-size: 12px;
  padding: 0 10px;
  border-radius: 12px;
  line-height: 24px;
  display: inline-block;
}
.tag-status.done {
  background: #e1f3d8;
  color: #67c23a;
}
.tag-status.pending {
  background: #fdf6ec;
  color: #e6a23c;
}
.tag-status.wait {
  background: #e9f0fc;
  color: #409eff;
}
.tag-status.default {
  background: #f4f4f5;
  color: #909399;
}

/* // 合计行样式 */
.table-wrap ::v-deep .el-table__footer-wrapper {
  font-weight: bold;
  .el-table__footer td {
    background-color: #f5f7fa;
  }
}
</style>
